import { EditorView } from '@tiptap/pm/view';
import { ResolvedPos } from '@tiptap/pm/model';
import { EditorState } from '@tiptap/pm/state';

export const getPrecedingChar = (view: EditorView) => {
  const { from } = view.state.selection;
  if (from > 0) {
    return view.state.doc.textBetween(from - 1, from);
  }
  return '';
};

export type IsInProps = (
  | {
      node: string;
    }
  | {
      nodeList: string[];
    }
) &
  (
    | {
        pos: ResolvedPos;
      }
    | {
        state: EditorState;
      }
  );

/**
 * Checks if current resolved position is inside a certain node
 * or list of nodes.
 * @param props
 * @returns
 */
export const isIn = (props: IsInProps) => {
  const parentDenyList = 'node' in props ? [props.node] : props.nodeList;
  const pos = 'pos' in props ? props.pos : props.state.selection.$head;

  for (let d = pos.depth; d > 0; d--) {
    if (parentDenyList.includes(pos.node(d).type.name)) {
      return true;
    }
  }
  return false;
};
